/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'

import { AuthService } from '@/services/auth.service'
import { API_URL } from '../.env'

export class Http {
  constructor(status) {
    this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: API_URL,
    })

    return this.init()
  }

  init() {
    if (this.isAuth) {
      this.instance.interceptors.request.use(
        (request) => {
          request.headers.authorization = AuthService.getBearer()

          return request
        },
        (error) => {
          return Promise.reject(error)
        }
      )

      this.instance.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response && error.response.status && error.response.status === 401) {
            AuthService.resetAuth()
          }

          return Promise.reject(error)
        }
      )
    }

    return this.instance
  }
}
